require("bootstrap/dist/js/bootstrap.min.js")
require("@popperjs/core/dist/umd/popper.min.js")

require("lazysizes")

exports.onClientEntry = () => {
  // Load your JavaScript library
  const script = document.createElement("script")
  script.src = "https://anymind360.com/js/8218/ats.js" // Replace with the actual path to your JavaScript library file
  script.async = true
  document.body.appendChild(script)
}

exports.onRouteUpdate = () => {
  // Code to execute on page load
  if (window.anymindTS != null) window.startAnymindTS()
  //window.alert("open")
}

exports.onPreRouteUpdate = () => {
  // Code to execute when the page transitions to another page
  if (window.anymindTS?.dispose) window.anymindTS.dispose()
}
